
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SRList from "../component/List";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/Akkhor";

export default function ListExtracPage() {
  const { user } = useSelector((state) => state.auth);
  const { year_id } = useSelector((state) => state.save);
  const [params, setParams] = useState('')
 

  useEffect(() => {
    let _params = 'type=2&viewtype=main&year_id='+year_id;
    _params += user && user.data && user.data.school_id>0?'&school_id='+user.data.school_id:0;
    setParams(_params)
  }, [year_id])// eslint-disable-line 

  const columns = [
    { name: "id", label: "ID",options: { filter: false,sort: true } },
    { name: "title", label: "Tiêu đề", width: 250 ,options: { filter: true,sort: true } },
    { name: "fullname", label: "Chủ nhiệm" ,options: { filter: true,sort: false }},
    { name: "datecreate",label: "Ngày đăng",
      options:{
        filter: false,sort: true ,
        customBodyRender: (value, tableMeta, updateValue) => {
          const time = new Date(value * 1000);
          return <Moment format="HH:mm DD/MM/YYYY">{time}</Moment>;
        },
      }
    },
    { name: "id", label: "Học sinh",options: { filter: false,sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
      
        return <Link to={"/list-students?class_id="+value}><span className="text-info">Danh sách</span></Link>;
      } } },
  ];
  
  return (
    <AkkhorLayout idrole="list-extrac">
    <SRList name="extrac" idrole="list-extrac" params={params} title="Ngoại khoá" defaultLimit={50} serverSide={true} columns={columns}></SRList>
    </AkkhorLayout>
  );
}
